import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getFuelStationEvents(companyId, query) {
  return dataTransferWrap(
    ModulesMap.FUEL_STATION_EVENTS,dtConfig[ModulesMap.FUEL_STATION_EVENTS].getFuelStationEvents,
    {
      urlParams: {
        companyId,
      },
       params: query,
    },
   
  )
}

function getFuelStationEvent(companyId, fuelEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_EVENTS,dtConfig[ModulesMap.FUEL_STATION_EVENTS].getFuelStationEvent, {
    urlParams: {
      companyId,
      fuelEventId,
    },
    ...data,
  })
}

function getFuelStationEventPreview(companyId, fuelEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_EVENTS,dtConfig[ModulesMap.FUEL_STATION_EVENTS].getFuelStationEventPreview, {
    urlParams: {
      companyId,
      fuelEventId,
    },
    ...data,
  })
}

function getFuelStationEventPopup(companyId, fuelEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_EVENTS,dtConfig[ModulesMap.FUEL_STATION_EVENTS].getFuelStationEventPopup, {
    urlParams: {
      companyId,
      fuelEventId,
    },
    ...data,
  })
}

function patchFuelStationEvent(companyId, fuelEventId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_EVENTS,dtConfig[ModulesMap.FUEL_STATION_EVENTS].patchFuelStationEvent, {
    urlParams: {
      companyId,
      fuelEventId,
    },
    ...data,
  })
}

export default {
  getFuelStationEvents,
  getFuelStationEvent,
  getFuelStationEventPreview,
  getFuelStationEventPopup,
  patchFuelStationEvent,
}
